import {RECEIVE_SKIN_INFO} from "../../constants/design/SkinActionTypes"

export const receiveSkinInfo = (skinInfo) => ({
  type: RECEIVE_SKIN_INFO,
  skinInfo
})
